import { PropsWithChildren } from "react";
import Sidebar from "./Sidebar";
import Cart from "./Cart";
export default function MainLayout({ children }: PropsWithChildren) {
    return (
        <div className="grid grid-cols-4 py-6 px-20 gap-5 bg-[#F4F4F4] min-h-screen max-md:grid-cols-none max-md:px-0 max-lg:p-4 max-xl:p-4 max-md:min-h-fit max-md:pb-[70px]">
            <Sidebar />
            {children}
            <Cart />
        </div>
    )
}